export const CAREGIVER_MANAGEMENT_DEFAULT_FILTER = {
  enabled: false,
  isLocked: false
}

export const CAREGIVER_MANAGEMENT_DEFAULT_SORT = {
  sortedColumn: 'firstName',
  sortedColumnOrder: 'ascend'
}

// page logger
export const CAREGIVER_MANAGEMENT_LOG_SCHEMA = [
  { id: 'externalId', name: 'External ID', type: 'text' },
  { id: 'caregiverFirstName', name: 'Caregiver First Name', type: 'text' },
  { id: 'caregiverLastName', name: 'Caregiver Last Name', type: 'text' },
  { id: 'phone', name: 'Caregiver Phone', type: 'text' },
  { id: 'referralSource', name: 'Referral Source', type: 'select' },
  { id: 'facility', name: 'Facility', type: 'select' },
  { id: 'companyDivision', name: 'Caregiver Organization', type: 'select' },
  { id: 'caseManager', name: 'Caregiver Case Manager', type: 'select' },
  { id: 'trainingDate', name: 'Medical device training', type: 'select' },
  { id: 'enabled', name: 'Include inactive', type: 'select' },
  { id: 'isLocked', name: 'Include locked', type: 'select' }
]

// "Include inactive" / "Include locked" are switches; log them only when ON
export const CAREGIVER_MANAGEMENT_TOGGLE_LOG_OPTIONS = {
  enabled: [{ value: true, title: 'Yes' }],
  isLocked: [{ value: true, title: 'Yes' }]
}

export const CAREGIVER_NOTIFICATIONS = [
  {
    key: 0,
    title: 'Patient',
    value: 1
  },
  {
    key: 1,
    title: 'Primary caregiver',
    value: 2
  }
]

export const CAREGIVER_MANAGEMENT_ASSIGNMENT_STATUS = [
  { key: 0, title: 'All', value: 0 },
  { key: 1, title: 'Only assigned', value: 1 },
  { key: 2, title: 'Only not assigned', value: 2 }
]

export const CAREGIVER_MANAGEMENT_MEDICAL_DEVICE_TRAINING = [
  {
    key: 0,
    title: 'All',
    value: null
  },
  {
    key: 1,
    title: 'With training',
    value: 'notnull:'
  },
  {
    key: 2,
    title: 'Without training',
    value: 'null:'
  }
]
